export default __webpack_public_path__ + "static/media/factory_manager_hero.4f72d267.jpg";